import { environment } from '../../environments/environment'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private http = inject(HttpClient);


  storeSubscription(pushSubscription: PushSubscription) {
    return this.http.post(`${environment.baseUrl}/notifications/store-subscription`, pushSubscription)
  }
}
